import browser from './browser';
import storage from './storage';
import { create } from './debug';
import { getRandomString, parseQueryString } from './utils';
import config from './config';
import User from './user';
import forEach from 'lodash/forEach';
import assign from 'lodash/assign';
import isFunction from 'lodash/isFunction';
import isPlainObject from 'lodash/isPlainObject';
import detector from 'detector';
import sensors from './sensorsdata.full';
import debounce from 'lodash/debounce';

import { pathToRegexp as pathRegExp } from 'path-to-regexp';

let log = create('sdata');
let error = create('sdata:error');

let identifyId = '';
// let sensors:any = null
// 事件ID 前缀
const ID_PREFIX = 'W';
const idPrefixReg = /^W/;

// referrer url
let prevUrl = '';

type PageID = {};

/**
 * 页面ID 配置
 * 支持格式如下：
 * 格式一：[path]:[pageId]
 * 格式二：[path]:[queryKey:'',[keyValue]:[pageId]]   queryKey：对应url query参数key，keyValue 对应参数的枚举值
 * 举例：
 * '/app/shop/numbers/list': {  //  /app/shop/numbers/list
        queryKey: 'type',
        'len5': 'Hn022',        //  /app/shop/numbers/list?type=len5
        'len6': 'Hn023',        //  /app/shop/numbers/list?type=len6
        'birthday': 'Hn024',    //  /app/shop/numbers/list?type=birthday
    },
 * 格式三：[path]:(query,pathname)=>{return [pageId];}
 * 举例：
 * '/app/shop/numbers/list-love': (query,pathname) => {
 *     return 'Hn025';
 * }
 */
const PAGE_ID = {
  '/': 'W002', // 首页
};

const getPageId = (pathname, query) => {
  let pageId = '';
  if (pathname) {
    forEach(PAGE_ID, (val: any, reg) => {
      if (pathRegExp(reg, []).test(pathname)) {
        // log('pathname===> success',key)
        if (isPlainObject(val)) {
          pageId = val[query[val.queryKey]] || val.default || '';
        } else if (isFunction(val)) {
          return val(query, pathname);
        } else {
          pageId = val;
        }
        return false;
      } else {
        // log('pathname===>',key)
      }
    });
  }
  return pageId;
};

const getCurrentPageId = (pathname = location.pathname, query = parseQueryString()) => {
  let pageId = getPageId(pathname, query);
  if (!pageId) {
    error('getCurrentPageId pageId not found. pathname:', pathname, 'query:', query);
  }
  return pageId;
};

// todo: 获取 referrer 有问题，需要深入研究下神策的
const getPrevPageId = () => {
  let pathname = '',
    // referrer = sensors ? get(sensors, '_.info.pageProp.url', '') : ''  //prevUrl || sensors._.getReferrer();
    referrer = sensors ? sensors!._.getReferrer() : '';
  let pageId = '';
  if (location.hostname && referrer) {
    try {
      let url = new URL(referrer);
      pathname = url.pathname;
      if (url.hostname === location.hostname) {
        pageId = getPageId(pathname, parseQueryString(referrer));
      }
    } catch (e) {}
  }

  return pageId;
};

const getClientType = () => {
  return 'PC_V2';
};

const getIdentifyId = () => {
  if (identifyId) {
    return identifyId;
  }
  const KEY = 'MM_IDENTIFY_ID';
  identifyId = <string>storage.getItem(KEY);
  if (!identifyId) {
    identifyId = Date.now() + '_' + getRandomString();
    storage.setItem(KEY, identifyId);
  }
  return identifyId;
};

const init = async () => {
  //import sensors from 'sa-sdk-javascript';

  // sensors = await import('sa-sdk-javascript')

  // import('./sensorsdata.full.js').then((a) => {
  //   console.log('sdata---->',a)
  // }).catch((e) => {
  //   console.log('sdata---->err ',e)
  // })

  // let res = await import('./sensorsdata.full')
  // log('sa-sdk init', res);
  // if (!res) {
  //     return error('sensors 载入异常');
  // }
  // return;
  // sensors = res.default;
  window.sensors = sensors;
  window.sa = sensors;
  sensors.init({
    server_url: config.production
      ? 'https://sa.memeyule.com:9001/sa'
      : 'https://test-sa.memeyule.com:9001/sa',
    // debug_mode: !config.production,
    debug_mode: false, //false,
    // disable_fetch: config.dev,
    show_log: false, //!config.production,
    send_type: 'ajax',
    use_client_time: true,
    // show_log: !config.production,
    // server_url: "https://test-sa.memeyule.com:9001/sa",
    // debug_mode: true,
    heatmap: {
      //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      //需要 JSSDK 版本号大于 1.7
      clickmap: 'default',
      scroll_delay_time: 4000,
      //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      //需要 JSSDK 版本号大于 1.9.1
      scroll_notice_map: 'not_collect',
      collect_elements: 'all',
      collect_element: function (target) {
        let { sa } = target.dataset;
        return !!sa;
      },
      custom_property: function (target) {
        return formatParams(target.dataset.sa, target.getAttribute('title'));
      },
    },

    // is_single_page: true,
    // is_track_single_page: true,
    // is_track_device_id:true,
    // debug_mode_upload:true,
  });

  log('sdata init');
  sensors.quick('isReady', function () {
    log('sdata ready');
  });

  sensors.identify(getIdentifyId(), true);
  if (User.isLogin()) {
    sensors.login(User.getUserId() + '');
  }
  sensors.registerPage({
    user_memeid: User.getUserId() + '',
    channel: User.getQdInfo().qd,
  });

  sensors.registerPage({
    client_type: getClientType(),
    $os: detector.os.name,
    $model: detector.device.name,
    // $os_version: String(detector.os.version),
    $browser: detector.browser.name,
    $browser_version: String(detector.browser.version),
    $browser_engine: detector.engine.name,

    current_url: location.href,
    referrer_url: document.referrer,
  });
  // log('referrer===>', sensors._.getReferrer(), document.referrer)
  // log('location.href===>', location.href)

  sensors.quick('autoTrack', {
    page_number: getCurrentPageId(),
    previous_page_number: getPrevPageId(),
  });
};

const login = (id) => {
  sensors && sensors.login(id);
};

const logout = () => {
  sensors && sensors.logout();
};

/**
 * 页面浏览 搜集
 */
const trackPageView = (page_number, page_desc) => {
  console.log('trackPageView', page_number, page_desc);
  sensors &&
    sensors.track('page_view', {
      page_number,
      page_desc,
    });
  // sensors.quick('autoTrackSinglePage', {
  //   page_number: page_number || getCurrentPageId(),
  //   previous_page_number: getPrevPageId(),
  // });
};

const trackCustomView = (id) => {
  sensors &&
    sensors.track('custom_view', {
      $url: ID_PREFIX + id.replace(idPrefixReg, ''),
      $referrer: sensors._.getReferrer(),
    });
};

/**
 * 点击事件 搜集
 * @param {Event} e
 * @param {Object|String} params  eg: {id:111,text:222} | id=111&text=222
 */
const trackClick = (e, params) => {
  if (sensors) {
    let data = {};
    let title = '';
    if (e) {
      data = sensors._.getEleInfo({ target: e.currentTarget });
      if (e.currentTarget) {
        e.currentTarget.getAttribute('title');
      }
    }
    data = sensors._.extend(data, formatParams(params, title));
    // log('trackClick', data,e.currentTarget,extra)
    sensors.track('$WebClick', data);
  }
};

const trackClickDebounce = debounce(trackClick, 300);

const formatParams = (params, title) => {
  if (typeof params === 'string') {
    if (params.indexOf('=') > -1) {
      params = parseQueryString(params);
    } else {
      params = {
        id: params,
      };
    }
  }
  return {
    $element_id: ID_PREFIX + params.id.replace(idPrefixReg, ''), // 点击按钮ID编号
    $element_content: params.text || title || '', // 点击按钮文本信息
    display_contents_concretely: params.desc || params.text || title || '', // 点击按钮核心数据
  };
};

/**
 * 自定义事件
 * @param {string} event_name 必选，事件名
 * @param {object} properties 可选，事件属性
 * @param {function} callback 可选，发送数据后回调
 */
const track = (event_name, properties, callback?) => {
  sensors && sensors.track(event_name, properties, callback);
};

const getSaProperties = (opt = {}) => {
  let res = {};
  try {
    res = assign(
      {},
      sensors._.info.properties(),
      sensors.store.getProps(),
      sensors.store.getSessionProps(),
      sensors._.info.currentProps,
      opt,
    );
  } catch (e) {
    console.error('getSaProperties error', e);
  }
  return res;
};

const sdata = {
  init,
  login,
  logout,
  trackPageView,
  trackClick,
  trackClickDebounce,
  track,
  trackCustomView,
  getSaProperties,
};

if (typeof window !== 'undefined') {
  window.sdata = sdata;
}

export default sdata;
